'use es6';

import { Record } from 'immutable';
import { AdWordsStatusMap, Networks } from 'AdsUI/lib/Constants';
import { parseUrl } from 'hub-http/helpers/url';
export const BASE_FIELDS = {
  // EntityDataCore
  id: null,
  network: Networks.ADWORDS,
  name: null,
  // AdDataCore
  accountId: null,
  campaignId: null,
  adGroupId: null,
  // GoogleAdsAd
  status: AdWordsStatusMap.ENABLED,
  displayUrl: null,
  conversionRate: null,
  finalUrl: null,
  description: null,
  description2: null,
  type: null,
  // Needed for optimistic updating
  previousState: null,

  getDisplayUrl() {
    if (this.displayUrl) {
      return this.displayUrl;
    }

    return [parseUrl(this.finalUrl).hostname, this.path1, this.path2].filter(Boolean).join('/');
  }

};
export default Record(BASE_FIELDS);